"use client";

import { c as _c } from "react/compiler-runtime";
import DottedMap from "dotted-map";
import { motion } from "motion/react";
import { useMemo, useRef } from "react";
interface MapProps {
  dots?: Array<{
    start: {
      lat: number;
      lng: number;
      label?: string;
    };
    end: {
      lat: number;
      lng: number;
      label?: string;
    };
  }>;
  lineColor?: string;
}
export default function WorldMap(t0) {
  const $ = _c(24);
  const {
    dots: t1,
    lineColor: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dots = t3;
  const lineColor = t2 === undefined ? "#0ea5e9" : t2;
  const svgRef = useRef(null);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    const map = new DottedMap({
      height: 100,
      grid: "diagonal"
    });
    t4 = map.getSVG({
      radius: 0.22,
      color: "currentColor",
      shape: "circle",
      backgroundColor: "transparent"
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const svgMap = t4;
  const projectPoint = _temp;
  const createCurvedPath = _temp2;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-full w-full pointer-events-none select-none absolute inset-0 bg-background dark:bg-background text-foreground dark:text-foreground [&>svg]:w-full [&>svg]:h-full [&>svg]:object-cover" dangerouslySetInnerHTML={{
      __html: svgMap
    }} />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== dots) {
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = (dot, i) => {
        const startPoint = projectPoint(dot.start.lat, dot.start.lng);
        const endPoint = projectPoint(dot.end.lat, dot.end.lng);
        return <g key={`path-group-${dot.start.lat}-${dot.start.lng}-${dot.end.lat}-${dot.end.lng}`}><motion.path d={createCurvedPath(startPoint, endPoint)} fill="none" stroke="url(#path-gradient)" strokeWidth="1" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            duration: 1,
            delay: 0.5 * i,
            ease: "easeOut"
          }} key={`path-${dot.start.lat}-${dot.start.lng}-${dot.end.lat}-${dot.end.lng}`} /></g>;
      };
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    t6 = dots.map(t7);
    $[4] = dots;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <stop offset="0%" stopColor="white" stopOpacity="0" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] !== lineColor) {
    t8 = <stop offset="5%" stopColor={lineColor} stopOpacity="1" />;
    t9 = <stop offset="95%" stopColor={lineColor} stopOpacity="1" />;
    $[8] = lineColor;
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <stop offset="100%" stopColor="white" stopOpacity="0" />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t8 || $[13] !== t9) {
    t11 = <defs><linearGradient id="path-gradient" x1="0%" y1="0%" x2="100%" y2="0%">{t7}{t8}{t9}{t10}</linearGradient></defs>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== dots || $[16] !== lineColor) {
    let t13;
    if ($[18] !== lineColor) {
      t13 = (dot_0, i_0) => <g key={`points-group-${dot_0.start.lat}-${dot_0.start.lng}-${dot_0.end.lat}-${dot_0.end.lng}`}><g key={`start-${dot_0.start.lat}-${dot_0.start.lng}-${i_0}`}><circle cx={projectPoint(dot_0.start.lat, dot_0.start.lng).x} cy={projectPoint(dot_0.start.lat, dot_0.start.lng).y} r="2" fill={lineColor} /><circle cx={projectPoint(dot_0.start.lat, dot_0.start.lng).x} cy={projectPoint(dot_0.start.lat, dot_0.start.lng).y} r="2" fill={lineColor} opacity="0.5"><animate attributeName="r" from="2" to="8" dur="1.5s" begin="0s" repeatCount="indefinite" /><animate attributeName="opacity" from="0.5" to="0" dur="1.5s" begin="0s" repeatCount="indefinite" /></circle></g><g key={`end-${dot_0.end.lat}-${dot_0.end.lng}-${i_0}`}><circle cx={projectPoint(dot_0.end.lat, dot_0.end.lng).x} cy={projectPoint(dot_0.end.lat, dot_0.end.lng).y} r="2" fill={lineColor} /><circle cx={projectPoint(dot_0.end.lat, dot_0.end.lng).x} cy={projectPoint(dot_0.end.lat, dot_0.end.lng).y} r="2" fill={lineColor} opacity="0.5"><animate attributeName="r" from="2" to="8" dur="1.5s" begin="0s" repeatCount="indefinite" /><animate attributeName="opacity" from="0.5" to="0" dur="1.5s" begin="0s" repeatCount="indefinite" /></circle></g></g>;
      $[18] = lineColor;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    t12 = dots.map(t13);
    $[15] = dots;
    $[16] = lineColor;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12 || $[22] !== t6) {
    t13 = <div className="w-full aspect-2/1 dark:bg-black bg-white rounded-lg relative font-sans">{t5}<svg ref={svgRef} viewBox="0 0 800 400" className="w-full h-full absolute inset-0 pointer-events-none select-none" role="img" aria-label="World map with connection paths">{t6}{t11}{t12}</svg></div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t6;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}
function _temp2(start, end) {
  const midX = (start.x + end.x) / 2;
  const midY = Math.min(start.y, end.y) - 50;
  return `M ${start.x} ${start.y} Q ${midX} ${midY} ${end.x} ${end.y}`;
}
function _temp(lat, lng) {
  const x = (lng + 180) * 2.2222222222222223;
  const y = (90 - lat) * 2.2222222222222223;
  return {
    x,
    y
  };
}